import { TIPTAP_PDF_STYLE_ADJUSTMENTS } from './pdfStyleAdjustments';

export const adjustUnderlineElements = (clonedDoc: Document) => {
  // 밑줄 요소 처리
  const clonedUnderline = clonedDoc.querySelectorAll('u');
  clonedUnderline.forEach(underline => {
    const element = underline as HTMLElement;

    // 자식 요소들에 강제로 밑줄 적용
    const applyUnderlineToChildren = (parentEl: HTMLElement) => {
      Array.from(parentEl.childNodes).forEach(childNode => {
        if (childNode.nodeType === Node.ELEMENT_NODE) {
          const childElement = childNode as HTMLElement;

          // 기존 text-decoration 확인 (s 태그인 경우 line-through 명시적 추가)
          const currentDecoration = childElement.style.textDecoration || '';
          const decorations = currentDecoration
            ? currentDecoration.split(' ')
            : [];

          // s 태그인 경우 line-through 강제 추가
          if (
            childElement.tagName.toLowerCase() === 's' &&
            !decorations.includes('line-through')
          ) {
            decorations.push('line-through');
          }

          // 밑줄 추가
          if (!decorations.includes('underline')) {
            decorations.push('underline');
          }

          childElement.style.textDecoration = decorations.join(' ');
          childElement.style.textDecorationThickness =
            TIPTAP_PDF_STYLE_ADJUSTMENTS.underline.textDecorationThickness;

          // 재귀적으로 하위 요소들에도 적용
          applyUnderlineToChildren(childElement);
        } else if (
          childNode.nodeType === Node.TEXT_NODE &&
          childNode.textContent?.trim()
        ) {
          // 텍스트 노드는 span으로 감싸서 스타일 적용
          const wrapper = clonedDoc.createElement('span');
          wrapper.style.textDecoration = 'underline';
          wrapper.style.textDecorationThickness =
            TIPTAP_PDF_STYLE_ADJUSTMENTS.underline.textDecorationThickness;
          wrapper.style.display = 'inline';

          const parent = childNode.parentNode;
          if (parent) {
            parent.insertBefore(wrapper, childNode);
            wrapper.appendChild(childNode);
          }
        }
      });
    };

    // u 태그 자체에 밑줄 스타일 적용
    element.style.textDecoration = 'underline';
    element.style.textDecorationThickness =
      TIPTAP_PDF_STYLE_ADJUSTMENTS.underline.textDecorationThickness;
    element.style.display = 'inline';
    element.style.opacity = '1';
    element.style.visibility = 'visible';

    // 자식 요소들에도 밑줄 적용
    applyUnderlineToChildren(element);
  });
};
